import ParentCompanyService from './service';

export * from './reqres';

export default ParentCompanyService;
